/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-indent */
/* eslint-disable no-underscore-dangle */

import React, { useEffect, useState } from 'react'
import { consultationSchema } from 'utils/Schema'
import useFormValidation from 'hooks/useFormValidation'
import classNames from 'classnames'
import { createAppointment } from 'api/appointment'
import useLazyFetching from 'hooks/useLazyFetching'

const BASE_URL = process.env.REACT_APP_BASE_URL;


const Form = ({ isShow, onCloseForm }) => {
  const [consultationFee, setConsultationFee] = useState(0)
  const [isPayPrompt, setPayPrompt] = useState(false)
  const [isSubmitting, setSubmitting] = useState(false)
  const [depts, setDepts] = useState([])
  const [docList, setDocList] = useState([])
  const [success, setSuccess] = useState(null)
  const fileInputRef = React.createRef()

  const { response, loading: loadingDocs } = useLazyFetching(
    BASE_URL + '/api/doctors?status=active&appointmentStatus=true&sort=priorityOrder',
    {
      method: 'GET',
    },
    isShow,
  )

  const { response: departments, loading: loadingDept } = useLazyFetching(
    BASE_URL + '/api/departments?status=active&appointmentStatus=true',
    {
      method: 'GET',
    },
    isShow,
  )

  console.log(isSubmitting, 'submittiinggg')

  useEffect(() => {
    if (departments && departments.data.length > 0) setDepts(departments.data)
  }, [departments])

  let departmentsRender = loadingDocs ? <option value="">--Loading--</option> : null
  let renderDoctorsOptions = loadingDept ? <option value="">--Loading--</option> : null

  if (!loadingDept)
    departmentsRender =
      depts && depts.length > 0 ? (
        <>
          <option value="">--Choose speciality--</option>
          {depts.map(i => (
            <option key={i._id} value={i._id}>
              {i.name}
            </option>
          ))}
        </>
      ) : (
        <option value="">Not available</option>
      )

  if (!loadingDocs)
    renderDoctorsOptions =
      docList.length > 0 ? (
        <>
          <option value="">--Choose doctor--</option>
          {docList.map(doctor => (
            <option key={doctor._id} value={doctor._id}>
              {doctor.name}
            </option>
          ))}
        </>
      ) : (
        <option value="">No doctors</option>
      )

  // let doctorsList = []
  // if (response && response.data) {
  //   doctorsList = response.data
  // }

  // const renderDoctorsOptions =
  //   doctorsList.length > 0 ? (
  //     doctorsList.map(doctor => (
  //       <option key={doctor._id} value={doctor.slug}>
  //         {doctor.name}
  //       </option>
  //     ))
  //   ) : (
  //     <option>No doctors</option>
  //   )

  const goToPayment = () => {
    setSubmitting(true)
    if (consultationFee > 0) return setPayPrompt(true)
    return submitForm()
  }

  /**
   *
   * @param {boolean} paymentStatus
   */
  const submitForm = async paymentStatus => {
    console.log('will submit form', values)
    setSubmitting(true)
    try {
      const a = await createAppointment(values, paymentStatus)
      if (a) {
        // setTimeout(() => setPayPrompt(false), 1500)
        setPayPrompt(false)
        setSuccess(true)
        setSubmitting(false)

        // setTimeout(() => onCloseForm(), 2000)
        onCloseForm()
      } else {
        setSuccess(false)
        setSubmitting(false)
        // setTimeout(() => onCloseForm(), 2000)
        onCloseForm()
        // setTimeout(() => window.location.reload(), 2000)
      }
    } catch (error) {
      console.error(error)
      setSuccess(false)
      setSubmitting(false)
      // setTimeout(() => onCloseForm(), 2000)
      // setTimeout(() => window.location.reload(), 2000)
    }
  }
  const {
    values,
    errors,
    onChange,
    onSubmit,
    setValues,
    // isSubmitting,
    // setSubmitting,
  } = useFormValidation(
    {
      gender: 'male',
      reports: [],
    },
    consultationSchema,
    goToPayment,
  )

  const onFileChange = () => {
    // console.log(fileInputRef.current.files)
    // const { files } = fileInputRef.current
    setValues(a => ({ ...a, reports: [...fileInputRef.current.files] }))
  }

  const openCheckout = () => {
    const options = {
      key: 'rzp_test_XgGz6DhptViygY',
      amount: consultationFee * 100, // 2000 paise = INR 20, amount in paisa
      name: 'Sabine Hospital',
      description: 'Always there..',
      image: '/resources/img/sabine-hospital-favicon/sabine-hospital-apple-touch-icon-144x144.png',
      handler: paymentRes => {
        // console.log(paymentRes)
        // console.log(paymentRes.razorpay_payment_id)
        if (paymentRes.razorpay_payment_id) submitForm(true)
      },
      prefill: {
        name: 'Harshil Mathur',
        email: 'harshil@razorpay.com',
      },
      notes: {
        address: 'Hello World',
      },
      theme: {
        color: '#F37254',
      },
    }

    const rzp = new Razorpay(options)
    rzp.open()
  }

  useEffect(() => {
    if (values.doctor && response && response.data) {
      // console.log(values.doctor)
      const doc = response.data.filter(i => {
        // console.log(i, values.doctor)
        return i._id === values.doctor
      })
      // console.log(doc)
      setConsultationFee(
        doc[0].consultationFee === 'null' || !doc[0].consultationFee ? 0 : doc[0].consultationFee,
      )
    }
  }, [values.doctor, response])

  // useEffect(() => {
  //   console.log('in useEffect', formValues)
  //   setValues({})
  //   setErrors({})
  // }, [formValues, setValues, setErrors])

  useEffect(() => {
    console.log('speciality changed', values.speciality)
    setConsultationFee(0)
    if (values.speciality && response && response.data) {
      const doctorsListDept = response.data.filter(i => i.department._id === values.speciality)
      // console.log(doctorsListDept)
      setDocList(doctorsListDept)
    }
  }, [values.speciality, response])

  let feeText = ''
  if (consultationFee > 0) {
    feeText = (
      <div
        className="col-lg-6"
        style={{ margin: '1em 0', display: isPayPrompt ? 'none' : 'block' }}
      >
        Your consultation fee is: Rs. <strong> {consultationFee}</strong>
      </div>
    )
  }

  return (
    <>
      <div className="booknow-popup-wrapper">
        <div className="row">
          <div className="col-lg-12">
            <h5>Book an appoinment</h5>
          </div>
          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.name || ''}>
              <input
                onChange={onChange}
                type="text"
                name="name"
                className={classNames('form-control', { error: errors.name })}
                placeholder="Name :"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.mobile || ''}>
              <input
                onChange={onChange}
                type="text"
                name="mobile"
                className={classNames('form-control', { error: errors.mobile })}
                placeholder="Mobile :"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.email || ''}>
              <input
                onChange={onChange}
                type="text"
                name="email"
                className={classNames('form-control', { error: errors.email })}
                placeholder="Email :"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.speciality || ''}>
              <div className="select-box">
                <select
                  onChange={onChange}
                  name="speciality"
                  defaultValue="--None--"
                  placeholder="Select Speciality"
                  className={classNames('form-control', { error: errors.speciality })}
                >
                  {departmentsRender}
                </select>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.doctor || ''}>
              <select
                onChange={onChange}
                name="doctor"
                className={classNames('form-control', { error: errors.doctor })}
              >
                {renderDoctorsOptions}
              </select>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.dateAppointment || ''}>
              <input
                onChange={onChange}
                type="date"
                name="dateAppointment"
                className={classNames('form-control', { error: errors.dateAppointment })}
                placeholder="Date Of Appointment :"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.gender || ''}>
              {/* <input onChange={onChange} type="radio" id="huey" name="gender" value="huey" checked={values.gender === "huey"} />
            <label htmlFor="huey">Huey</label>
            <input onChange={onChange} type="radio" id="dewey" name="gender" value="dewey" checked={values.gender === "dewey"} />
            <label htmlFor="dewey">Dewey</label>
            <input onChange={onChange} type="radio" id="louie" name="gender" value="louie" checked={values.gender === "louie"} />
            <label htmlFor="louie">Louie</label> */}
              <div className="form-group">
                <label htmlFor="male" className="radio-container">
                  Male
                  <input
                    id="male"
                    className="checkmark"
                    onChange={onChange}
                    value="male"
                    type="radio"
                    checked={values.gender === 'male'}
                    name="gender"
                  />
                </label>
                <span className="checkmark" />

                <label htmlFor="female" className="radio-container">
                  Female
                  <input
                    className="checkmark"
                    id="female"
                    value="female"
                    onChange={onChange}
                    type="radio"
                    checked={values.gender === 'female'}
                    name="gender"
                  />
                </label>
                <span className="checkmark" />
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.age || ''}>
              <input
                onChange={onChange}
                type="text"
                name="age"
                className={classNames('form-control', { error: errors.age })}
                placeholder="Age :"
              />
            </div>
          </div>

          <div className="col-lg-12">
            <div className="form-group" data-tip={errors.address || ''}>
              <textarea
                onChange={onChange}
                id=""
                cols="30"
                rows="10"
                name="address"
                className={classNames('form-control', { error: errors.address })}
                placeholder="Address :"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.hospitalNo || ''}>
              <input
                onChange={onChange}
                type="text"
                name="hospitalNo"
                className={classNames('form-control', { error: errors.hospitalNo })}
                placeholder="Hospital Number :"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.country || ''}>
              <input
                onChange={onChange}
                type="text"
                name="country"
                className={classNames('form-control', { error: errors.country })}
                placeholder="Country/Region :"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.state || ''}>
              <input
                onChange={onChange}
                type="text"
                name="state"
                className={classNames('form-control', { error: errors.state })}
                placeholder="State/Province :"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.city || ''}>
              <input
                onChange={onChange}
                type="text"
                name="city"
                className={classNames('form-control', { error: errors.city })}
                placeholder="City :"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.pincode || ''}>
              <input
                onChange={onChange}
                type="text"
                name="pincode"
                className={classNames('form-control', { error: errors.pincode })}
                placeholder="Pincode :"
              />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="form-group" data-tip={errors.referringPhysician || ''}>
              <input
                onChange={onChange}
                name="referringPhysician"
                type="text"
                className={classNames('form-control', { error: errors.referringPhysician })}
                placeholder="Reffering Physician Name :"
              />
            </div>
          </div>

          <div className="col-lg-12">
            <div className="form-group" data-tip={errors.medicalHistory || ''}>
              <textarea
                onChange={onChange}
                name="medicalHistory"
                id=""
                cols="30"
                rows="10"
                className={classNames('form-control', { error: errors.medicalHistory })}
                placeholder="History and difficulties"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div data-tip={errors.reports || ''} className="form-group">
              <label htmlFor="reports">
                Add report(s)
                <input
                  onChange={onFileChange}
                  name="reports"
                  ref={fileInputRef}
                  type="file"
                  accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, image/png, image/jpeg"
                  required
                  files={values.reports}
                  multiple
                  className={classNames('form-control', { error: errors.reports })}
                />
              </label>
            </div>
          </div>
          {feeText}

          <div className="col-lg-12" style={{ display: isPayPrompt ? 'none' : 'block' }}>
            <button onClick={onSubmit} disabled={isSubmitting} type="button" className="btn">
              Submit
            </button>
          </div>

          {/* success message */}
          <div
            style={{
              display: success === true ? 'block' : 'none',
              width: '100%',
              padding: '1em',
            }}
          >
            Form submitted. You will hear from us shortly
          </div>
          {/* error message */}
          <div
            style={{
              display: success === false ? 'block' : 'none',
              width: '100%',
              padding: '1em',
            }}
          >
            Error submitting form. Please try again later
          </div>

          {isPayPrompt && (
            <div
              className="consult-alert"
              style={{ display: success === (false || true) ? 'none' : 'block' }}
            >
              <div className="consult-msg">
                <div>
                  Your appointment fee is: <strong>{consultationFee}</strong>.
                </div>
                <div> Would you like to pay now or later?</div>
              </div>
              <div className="pay">
                <div style={{ marginLeft: 'auto' }}>
                  <button onClick={() => openCheckout()} className="btn" type="button">
                    Pay now
                  </button>
                </div>
                <div style={{ marginLeft: '1em' }}>
                  <button onClick={() => submitForm()} className="btn inverse" type="button">
                    Pay later
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* <div className="consult-alert show">
        <div className="consult-msg">
          <div>
            Your appointment fee is: <strong>{consultationFee}</strong>.
          </div>
          <div> Would you like to pay now or later?</div>
        </div>
        <div className="row">
          <div style={{ marginLeft: 'auto' }}>
            <button onClick={() => openCheckout()} className="btn" type="button">
              Pay now
            </button>
          </div>
          <div style={{ marginLeft: '1em' }}>
            <button onClick={() => submitForm()} className="btn inverse" type="button">
              Pay later
            </button>
          </div>
        </div>
      </div> */}
      {/* <Modal isShow={isPayPrompt} handleModalClose={() => setPayPrompt(false)}>
        <Modal.Body>
          <div className="consult-alert">
            <div className="consult-msg">
              <div>
                Your appointment fee is: <strong>{consultationFee}</strong>.
              </div>
              <div> Would you like to pay now or later?</div>
            </div>
            <div className="row">
              <div style={{ marginLeft: 'auto' }}>
                <button onClick={() => openCheckout()} className="btn" type="button">
                  Pay now
                </button>
              </div>
              <div style={{ marginLeft: '1em' }}>
                <button onClick={() => submitForm()} className="btn inverse" type="button">
                  Pay later
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  )
}

export default Form
